/** @format */
import { creditRangeEditorModule } from './creditRangeEditor.dir';
import { decimalInputModule } from './decimalInput.dir';
import { percentEditorModule } from './percentEditor.dir';

export const commonNumberModule = 'sis-components.number';

(function () {
    angular.module(commonNumberModule, [
        creditRangeEditorModule,
        decimalInputModule,
        percentEditorModule,
        'sis-components.number.creditRangeFilter',
        'sis-components.number.decimalNumberFilter',
        'sis-components.number.intRangeFilter',
        'sis-components.number.percentFilter',
    ]);
})();
